<template>
  <modal :modalUrl="modalUrl"
         :leaveButtonClasses="additionalClass"
         :dialogClasses="dialogClass"
         @modalMounted="handleMount($event)"
         @stayLinkClicked="closeModal"
         @leaveLinkClicked="closeModal"
         :newWindow="true">
    <template v-slot>
      <div v-html="messageHtml"></div>
    </template>
  </modal>
</template>

<script>
import { onMounted, reactive, ref } from 'vue';
import { decodeHtml } from '../helpers/html';
import Modal from './Modal.vue';

export default {
  components: {
    Modal
  },
  name: 'SpeedBump',
  props: {
    message: {
      type: String,
      required: true,
    },
    urls: {
      type: Array,
      required: true,
    }
  },
  setup(props) {
    const additionalClass = 'offsite-link';
    const dialogClass = 'modal-dialog-centered'
    const messageHtml = decodeHtml(props.message);
    const urlArray = reactive(props.urls.map((url) => url));
    const modalUrl = ref('');
    let modal = undefined;

    const openModal = () => {
      if (modal) {
        modal.show();
      }
    };

    const closeModal = () => {
      if (modal) {
        modal.hide();
      }
    };

    const handleMount = (modalEvent) => {
      modal = modalEvent
    };

    const watchLink = (event) => {
      const self = event.currentTarget;
      if (self) {
        const url = self.getAttribute('href');
        // eslint-disable-next-line no-script-url
        if (
          url &&
          !url.startsWith('#') &&
          !url.includes('javascript:') &&
          !self.classList.contains('offsite-link') &&
          !url.includes('tel:') &&
          !url.includes('mailto:')
        ) {
          if (self.host !== window.location.host) {
            event.preventDefault();
            const safe = urlArray.some((u) => url.includes(u));

            if (modal && !safe) {
              modalUrl.value = url;
              openModal();
            } else {
              window.location.href = url;
            }
          }
        }
      }
    };

    onMounted(() => {
      const links = document.querySelectorAll('a');
      links.forEach((link) => {
        link.addEventListener('click', watchLink);
      });
    });

    return {
      messageHtml,
      modalUrl,
      additionalClass,
      handleMount,
      closeModal,
      dialogClass
    };
  }
};
</script>
